import { parseVersionToNumber } from '@shared/utils'
import { getDeviceSpace, getInnerApiProxyData } from './proxy'
import { store } from '@remote/store'

/**
 * 移除已有的刮削目录
 */
export const getBaseConfig = (space: string) => {
  const currentNumericVersion = parseVersionToNumber(store.state?.deviceInfoWatchData?.client_version ?? '0.0.0')
  const olderNumericVersion = parseVersionToNumber('3.1.0')
  const isOlderVersion = currentNumericVersion < olderNumericVersion
  const params = isOlderVersion
    ? {
      device_space: space,
    }
    : {
      space: space,
      device_space: getDeviceSpace(),
      play_scenes: ['nfo', 'download_list'],
    }
  return getInnerApiProxyData({
    proxyUrl: 'device/v1/get_config',
    proxyMethod: 'GET',
    proxyParams: params,
  }) as Promise<API_DEVICE.BaseConfig>
}

export const API = {
  getBaseConfig,
}